export const wallboxLockHelp =
  "Um den Status Ihrer Wallbox (Gesperrt/Entsperrt) zu ändern bzw. Ihre Wallbox zu (ent)sperren, klicken Sie auf das " +
  "Schloss-Symbol. Sie können die Wallbox dauerhaft entsperrt lassen (z. B. wenn diese sich in Ihrer Garage " +
  "befindet) oder nach dem Ladevorgang sperren, um zu verhindern, dass Unbefugte Ihre Wallbox nutzen.";
export const wallboxState = "Status";
export const wallboxLockedState = "Gesperrt";
export const wallboxUnlockedState = "Entsperrt";
export const wallboxLockedStateTimeSettings = "Sperrzeiten einstellen";

export const surplusChargingTitle = "PV-Überschussladen";
export const surplusChargingHelpBase =
  "Beim PV-Überschussladen wird Ihre Wallbox das Elektrofahrzeug nur laden, wenn Ihre PV-Anlage mehr " +
  "Strom produziert als Sie verbrauchen.";
export const surplusChargingHelp =
  surplusChargingHelpBase +
  " Dies ermöglicht eine optimale Nutzung Ihrer Energie, da Sie lediglich Ihr " +
  "Fahrzeug laden, wenn Ihre PV-Anlage Strom produziert und so das Laden mit vergleichsweise teurem Netzstrom verhindert " +
  "wird. Die Wallbox beginnt das Fahrzeug zu laden, sobald Ihr Überschuss die minimale Ladeenergie der Wallbox " +
  "übersteigt. Die Ladeenergie wird fortlaufend an Ihren Überschuss angepasst. Bitte beachten Sie, dass ein " +
  "Ladevorgang mit PV-Überschuss - je nach Produktion Ihrer PV-Anlage - sehr lange dauern kann.";

export const hybridChargingTitle = "PV-Hybridladen";

export const hybridChargingHelpBase =
  "Beim PV-Hybridladen wird Ihr Fahrzeug mindestens mit einer von Ihnen gewählten Leistung geladen";
export const hybridChargingHelp =
  hybridChargingHelpBase +
  " Übersteigt der PV-Überschuss die angegebene Mindestleistung, wird Ihr Elektrofahrzeug mit dem zur Verfügung " +
  "stehenden Überschuss geladen. Dies ermöglicht eine effiziente Nutzung Ihrer PV-Erzeugung bei gleichzeitiger Sicherstellung " +
  "einer ausreichenden Ladung Ihres Fahrzeugt.";
// export const hybridChargingHelp =
//   "Wenn Sie wünschen, dass Ihr E-Fahrzeug im hybriden Modus mit der Mindestleistung aus dem Netz bzw. der Batterie und " +
//   "zusätzlichem PV-Überschuss geladen wird, aktivieren Sie das PV-Hybridladen. Die Wallbox beginnt sofort, das Auto " +
//   "zu laden, auch wenn der PV-Überschuss die Mindestleistung nicht erreicht. Die zusätzliche Ladeenergie, die nicht " +
//   "auch dem Netz oder der Batterie kommt, wird fortlaufend an Ihren Überschuss angepasst.";

export const hybridChargingCurrentHelp =
  "Hier können Sie den Ladestrom zwischen 6A und 16A einstellen, mit dem mindestens geladen wird, auch wenn kein " +
  "Überschuss vorhanden ist.";
export const hybridChargingCurrent = "Minimaler Ladestrom";
